import instance from '../utils/axios';

export const fetchUserGeneralSetting = async () => {
    const response = await instance.get('/api/generalsetting');
    return response.data;
}

export const updateGeneralSetting = async (data) => {
    const response = await instance.post('/api/generalsetting', data);
    return response.data;
}